import { types, flow } from 'mobx-state-tree'
import dayjs from 'dayjs'

import { API } from '../api'
const { model, maybeNull, number, string, boolean } = types

const Spouse = model({
  annualIncome: maybeNull(number),
  birthDate: maybeNull(string),
  expectedMortalityAge: maybeNull(number),
  firstName: maybeNull(string),
  gender: maybeNull(string),
  id: maybeNull(number),
  includeSsi: maybeNull(boolean),
  lastName: maybeNull(string),
  middleInitial: maybeNull(string),
  otherIncome: maybeNull(number),
  retirementAge: maybeNull(number),
  retirementIncomeGoalPct: maybeNull(number),
  socSecNum: maybeNull(string),
  strbirthdate: maybeNull(string),
  totalIncome: maybeNull(number),
}).views(self => ({
  // Plan-year age (see Person.age) vs. age as of today (see Person.ageToday).
  get age() {
    return self.birthDate && dayjs().year() - dayjs(self.birthDate).year()
  },
  get ageToday() {
    return self.birthDate && dayjs().diff(dayjs(self.birthDate), 'year')
  },
  // The day the spouse reaches their stated retirement age. Null until we hold
  // both halves of it.
  get retirementDate() {
    if (!self.birthDate || self.retirementAge == null) return null
    return dayjs(self.birthDate).add(self.retirementAge, 'year')
  },
  // Whether that day has already arrived. Deliberately measured against age as
  // of today (see Person.ageToday), not the plan-year age, so a spouse whose
  // retirement birthday is still months away is not called retired.
  get isRetired() {
    return self.retirementDate != null && !self.retirementDate.isAfter(dayjs())
  },
}))

const SpouseStore = model({
  spouse: maybeNull(Spouse),
}).actions(self => ({
  getSpouse: flow(function* () {
    const spouse = yield API.get('person/spouse')
    self.spouse = spouse.data || {}
  }),
  createSpouse: flow(function* (values) {
    const spouse = yield API.post('person/spouse', values)
    self.spouse = spouse.data
  }),
  updateSpouse: flow(function* (values) {
    const spouse = yield API.patch('person/spouse', values)
    self.spouse = spouse.data
  }),
}))

export default SpouseStore
